import React from "react";
import OthersHero from "./OthersHero";

const ServiceHero = () => {
  return (
    <div className="">
      {" "}
      <div className="about-hero-wrapper h-75">
        <OthersHero otherheading="Services" />
      </div>
    </div>
  );
};

export default ServiceHero;
